module.exports = __webpack_public_path__ + "img/zw.45bfaf06.svg";